<ng-container [ngSwitch]="easElement.controlType">
  <ng-container *ngSwitchCase="'group'">
    <eas-easform-group [easGroup]="easElement"
                       [templates]="templates"
                       [forceDisplayReadOnly]="forceDisplayReadOnly"></eas-easform-group>
  </ng-container>
  <ng-container *ngSwitchCase="'array'">
    <eas-easform-array [easArray]="easElement"
                       [templates]="templates"
                       [forceDisplayReadOnly]="forceDisplayReadOnly"></eas-easform-array>
  </ng-container>
  <ng-container *ngSwitchCase="'control'">
    <eas-easform-control [easControl]="easElement"
                         [templates]="templates"
                         [forceDisplayReadOnly]="forceDisplayReadOnly"></eas-easform-control>
  </ng-container>
</ng-container>